/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AlarmOverview } from './alarmOverview';


export interface MachineAlarmsOverviewResponse { 
    data?: Array<AlarmOverview>;
    totalItems?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;
}

